const ROUTES = {
  ROOT: '/',
  MINT: '/mint-nfts',
  ARTWORKS: '/artworks',
  MY_ARTWORKS: '/my-artworks',
  ADMIN: '/admin',
  ADD_ADMIN: '/admin/add',
  FAQ_WALLET: '/faq/wallet',
  FAQ_COIN: '/faq/buy-coins',
  FAQ_CREATION: '/faq/nft-creation',
  FAQ_GAS: '/faq/gas-fees',
  FAQ_SELL: '/faq/sell-nfts',
  NOT_FOUND: '*',
};
export default ROUTES;
